import React from 'react'

const Feautured = () => {
    return (
        <div>
            {/* <!-- Featured car start --> */}
            <div className="featured-car content-area">
                <div className="container">
                    {/* <!-- Main title --> */}
                    <div className="main-title">
                        <h1>LOS MAS IMPORTADOS...</h1>
                        <p>Estos son los autos mas importados este mes</p>
                    </div>
                    <div className="row">

                        <div className="col-lg-4 col-md-6">
                            <div className="car-box-3">
                                <div className="car-thumbnail">
                                    <a href="car-details.html" className="car-img">
                                        <div className="for">FRONTERIZO</div>
                                        <div className="price-box">
                                            <span className="del"><del>$950.00</del></span>
                                            <br/>
                                            <span>$1050.00</span>
                                        </div>
                                        <img className="d-block w-100" src="https://firebasestorage.googleapis.com/v0/b/wti-services-jrz.appspot.com/o/option06.png?alt=media&token=7e982809-61b3-425c-a123-b17989498a09" alt="car"/>
                                    </a>
                                    
                                </div>
                                <div className="detail">
                                    <h1 className="title">
                                        <a>Nissan Sentra 2012</a>
                                    </h1>
                                    <ul className="custom-list">
                                        <li>
                                            <a href="#">Fronterizo</a> /
                                        </li>
                                        <li>
                                            <a href="#">Automatic</a> /
                                        </li>
                                        <li>
                                            <a href="#">sedan</a>
                                        </li>
                                    </ul>
                                    <ul className="facilities-list clearfix">
                                        <li>
                                            <i className="flaticon-fuel"></i> Gasolina
                                        </li>
                                        
                                        <li>
                                            <i className="flaticon-manual-transmission"></i> Manual
                                        </li>
                                    
                                        <li>
                                            <i className="flaticon-calendar-1"></i> 2012
                                        </li>
                                    </ul>
                                </div>                   
                            </div>
                        </div>

                        <div className="col-lg-4 col-md-6">
                            <div className="car-box-3">
                                <div className="car-thumbnail">
                                    <a href="car-details.html" className="car-img">
                                        <div className="tag-2 bg-active">NACIONAL</div>
                                        <div className="price-box"> 
                                            <span className="del"><del>$805.00</del></span>
                                            <br/>
                                            <span>$780.00</span>
                                        </div>   
                                        <img className="d-block w-100" src="https://firebasestorage.googleapis.com/v0/b/wti-services-jrz.appspot.com/o/option05.png?alt=media&token=4c23f3ba-e7d9-4f23-8510-9073fa9e07af" alt="car"/>
                                    </a>                        
                                </div>
                                <div className="detail">
                                    <h1 className="title">
                                        <a href="car-details.html">Ford Focus 2012</a>
                                    </h1>
                                    <ul className="custom-list">
                                        <li>
                                            <a href="#">Nacional</a> /
                                        </li>
                                        <li>
                                            <a href="#">Automatico</a> /
                                        </li>
                                        <li>
                                            <a href="#">sedan</a>
                                        </li>
                                    </ul>
                                    <ul className="facilities-list clearfix">
                                        <li>
                                            <i className="flaticon-fuel"></i> Gasolina
                                        </li>
                                    
                                        <li>
                                            <i className="flaticon-manual-transmission"></i> Automatico
                                        </li>
                                    
                                        <li>
                                            <i className="flaticon-calendar-1"></i> 2019
                                        </li>
                                    </ul>
                                </div>                   
                            </div>
                        </div>

                        <div className="col-lg-4 col-md-6">
                            <div className="car-box-3">
                                <div className="car-thumbnail">
                                    <a href="car-details.html" className="car-img">
                                        <div className="for">fronterizo</div>
                                        <div className="price-box">
                                            <span className="del"><del>$830.00</del></span>
                                            <br/>
                                            <span>$940.00</span>
                                        </div>
                                        <img className="d-block w-100" src="https://firebasestorage.googleapis.com/v0/b/wti-services-jrz.appspot.com/o/option04.png?alt=media&token=cb56cb9a-32c6-4f2e-9bb9-095d5d00e56d" alt="car"/>
                                    </a>
                                    
                                </div>
                                <div className="detail">
                                    <h1 className="title">
                                        <a href="car-details.html">Chrysler 200 2016</a>
                                    </h1>
                                    <ul className="custom-list">
                                        <li>
                                            <a href="#">Fronterizo</a> /
                                        </li>
                                        <li>
                                            <a href="#">Manual</a> /
                                        </li>
                                        <li>
                                            <a href="#">sedan</a>
                                        </li>
                                    </ul>
                                    <ul className="facilities-list clearfix">
                                        <li>
                                            <i className="flaticon-fuel"></i> Gasolina
                                        </li>
                                    
                                        <li>
                                            <i className="flaticon-manual-transmission"></i> Manual
                                        </li>
                                    
                                        <li>
                                            <i className="flaticon-calendar-1"></i> 2018
                                        </li>
                                    </ul>
                                </div>
                                
                            </div>
                        </div>

                     
                        </div>
                    </div>
                </div>
            {/* <!-- Featured car end --> */}                        
        </div>
    )
}

export default Feautured




// WEBPACK FOOTER //
// ./src/components/Feautured.jsx